export class PublicManfrediteResponseFact {
}
//# sourceMappingURL=public-manfredite.response.fact.js.map